import { SvgConverterTool } from '@/features/svg-converter'

export function SvgConverterPage() {
  return <SvgConverterTool />
}
